module.exports = __webpack_public_path__ + "media/images/sp/top/keyword_family@3x-c945ccf1d27e0d48e183ddb5ab139635.webp";